import { useEffect } from "react";
import { useNavigate } from "react-router";

import {
  type FeatureFlagKeys,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";

export type UseFeatureFlagGuardResult = {
  isLoading: boolean;
  isFeatureEnabled: boolean;
};

export const useFeatureFlagGuard = (
  featureFlagKey: FeatureFlagKeys,
  /**
   * If redirectPath is provided, the hook will navigate to the redirectPath if the feature flag is disabled.
   * If redirectPath is not provided, the hook will not navigate automatically
   */
  redirectPath?: string,
): UseFeatureFlagGuardResult => {
  const { featureFlag, isLoading } = useFeatureFlag();
  const navigate = useNavigate();

  const isFeatureEnabled = featureFlag[featureFlagKey];

  useEffect(() => {
    if (!isLoading && !isFeatureEnabled && redirectPath) {
      navigate(redirectPath, { replace: true });
    }
  }, [isLoading, isFeatureEnabled, navigate, redirectPath]);

  return {
    isLoading,
    isFeatureEnabled,
  };
};
